<account-corrections-container
  current-state-url="vm.$state.current.url"
  selected-person="vm.$scope.selectedPerson"
  set-selected-person="vm.$scope.setSelectedPerson"
  will-leave="vm.willLeave"
  on-will-leave-result="onWillLeaveResult"
/>
